import type { Content } from "@/modules/jobSearchPrefiltered/types"

import { useQuery } from "@tanstack/react-query"
import { usePathname } from "next/navigation"

import { QUERY_CACHE_TIME, QUERY_STALE_TIME } from "@/modules/community/constants/enums"
import { PREFILTERED_JOB_SEARCH_CONTENT_QUERY_KEY } from "@/modules/jobSearchPrefiltered/server/constants"
import { getContent } from "@/modules/jobSearchPrefiltered/services/getContent"
import { getSlugFromUrlOrPathname } from "@/modules/jobSearchPrefiltered/utils/getSlugFromUrlOrPathname"
import { useLocale } from "@/modules/locales/useLocale"

export type UseContentResult = {
  data?: Content
  isLoading: boolean
  isSuccess: boolean
  isError: boolean
}

export const useContent = (): UseContentResult => {
  const locale = useLocale()
  const pathname = usePathname()
  const prefilteredSlug = getSlugFromUrlOrPathname(pathname)

  const {
    data,
    isPending: isLoading,
    isSuccess,
    isError,
  } = useQuery({
    enabled: !!prefilteredSlug,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getContent({ locale, slug: `${prefilteredSlug}` }),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [PREFILTERED_JOB_SEARCH_CONTENT_QUERY_KEY, locale, prefilteredSlug],
    staleTime: QUERY_STALE_TIME,
  })

  return {
    data,
    isError,
    isLoading,
    isSuccess,
  }
}
